export default {"src":"/_next/static/media/stag_turun.09d5aee0.svg","height":268,"width":267,"blurWidth":0,"blurHeight":0};